import { IMG_HUMAN } from '@repo/assets';
import { Button, Modal } from '@successmode-ktp/kui';
import { ModalButton } from '@successmode-ktp/kui/dist/components/Modal/ModalButton';
import React from 'react';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  title: React.ReactNode;
  questionTitle: string;
  questionText: string;
  answerTitle: string;
  answerText: string;
  btnTitle: string;
  onClick: () => void;
};

export const BankCallGuideModal = ({
  isOpen,
  title,
  questionTitle,
  questionText,
  answerTitle,
  answerText,
  btnTitle,
  onClick,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ width: '100%', maxWidth: '340px' }}
    >
      <Modal.Header>
        <TitleWrapper>{title}</TitleWrapper>
      </Modal.Header>
      <ContentsWrapper>
        <QuestionWrapper isQuestion>
          <QuestionTitle isQuestion>
            <img src={IMG_HUMAN} alt='' width={20} height={25} />
            {questionTitle}
          </QuestionTitle>
          <QuestionText isQuestion>{questionText}</QuestionText>
        </QuestionWrapper>
        <QuestionWrapper>
          <QuestionTitle>{answerTitle}</QuestionTitle>
          <QuestionText>{answerText}</QuestionText>
        </QuestionWrapper>
      </ContentsWrapper>
      <Modal.Footer>
        <Modal.Button type='button' onClick={onClick}>
          {btnTitle}
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  );
};

type StyleProps = {
  isQuestion?: boolean;
};

const TitleWrapper = styled.span`
  font-weight: 600;
  line-height: 150%;
  font-size: 16px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`;

const QuestionWrapper = styled.dl<StyleProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 12px;
  background-color: ${({ isQuestion }) => (isQuestion ? '#f5f6f7' : '#F4F8FF')};
`;

const QuestionTitle = styled.dt<StyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 12px;
  flex: 1;
  min-width: 36px;
  padding: 4px 12px;
  color: ${({ isQuestion }) => (isQuestion ? '#80848a' : '#fff')};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  word-break: keep-all;
  background-color: ${({ isQuestion }) => (isQuestion ? '#e5e6e8' : '#246CF6')};
`;

const QuestionText = styled.dd<StyleProps>`
  flex: 4;
  text-align: left;
  border-radius: 12px;
  padding: 4px;
  color: ${({ isQuestion }) => (isQuestion ? '#3a3b3e' : '#246CF6')};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;
